export const getEaTravelRates = (state) => state.eaTravelRates;
